﻿import * as eventTypes from '../../map/utils/eventTypes';
import * as geomTypes from '../../map/utils/geomTypes';

export default class TemporaryEditControl {
    constructor(mapId, mapContainer, resourcesHandler, classId) {
        this.mapId = mapId;
        this.mapContainer = mapContainer;
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.temporaryEditWrapper = 'temporary-edit-wrapper-' + this.classId;
        this.temporaryEditContainer = 'temporary-edit-container-' + this.classId;
        this.saveEdit = 'temporary-save-edit-' + this.classId;
        this.cancelEdit = 'temporary-cancel-edit-' + this.classId;
        this.startEdit = 'temporary-start-edit-' + this.classId;
        this.startMove = 'temporary-start-move-' + this.classId;
        this.removeFeature = 'temporary-remove-feature-' + this.classId;
        this.features = [];
        this.modifiedFeatures = [];
        this.layerSettings = null;
        this._registerEventHandlers();
    }

    _registerEventHandlers() {
        $event.register(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, this._getTemporaryLayerSelectionChangedHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_MODIFIED, this._getFeatureModifiedHandler(), this, this.classId);
    }

    _getTemporaryLayerSelectionChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                if (data.features != null || data.isNew) {
                    this._showEditOptions(data.features == null ? [] : data.features, data.layerSettings);
                } else {
                    this._hideEditOptions();
                }
            } else {
                this._hideEditOptions();
            }
        };

        return handler;
    }

    _getFeatureModifiedHandler() {
        var handler = (eventName, data, sender) => {
            this.modifiedFeatures = data.features;
            if(document.getElementById(this.saveEdit).classList.contains('disabled')) {
                document.getElementById(this.saveEdit).classList.remove('disabled');
                document.getElementById(this.saveEdit).addEventListener('click', () => {
                    if (this.layerSettings.geometryType != geomTypes.GEOM_POINT) {
                        this._hideEditOptions();
                    } else {
                        this.features = data.features;
                        document.getElementById(this.startEdit).classList.remove('selected'); 
                    }
                    $event.notify(eventTypes.LAYER_SELECTION_CLEARED, { layerId: this.layerSettings.name }, this, this.classId);
                    $event.notify(eventTypes.FEATURES_MODIFIED, { oldFeatures: this.features, newFeatures: this.modifiedFeatures, layerId: this.layerSettings.name }, this, this.classId);
                });
            }

            if (this.modifiedFeatures.length > 0 && this.layerSettings.geometryType != geomTypes.GEOM_POINT) {
                document.getElementById(this.removeFeature).style.display = 'block';

                if (document.getElementById(this.startMove) != null) {
                    document.getElementById(this.startMove).style.display = 'block';
                }

                if (this.features.length == 0) {
                    document.getElementById(this.removeFeature).style.display = 'none';
                } else {
                    document.getElementById(this.cancelEdit).style.display = 'block';
                }
            } else {
                document.getElementById(this.removeFeature).style.display = 'none';

                if (document.getElementById(this.startMove) != null) {
                    document.getElementById(this.startMove).style.display = 'none';
                }

                document.getElementById(this.cancelEdit).style.display = 'none';

                if (this.layerSettings.geometryType != geomTypes.GEOM_POINT) {
                    this._hideEditOptions();
                } else {
                    this.features = data.features;
                    document.getElementById(this.startEdit).classList.remove('selected');
                }
                $event.notify(eventTypes.LAYER_SELECTION_CLEARED, { layerId: this.layerSettings.name }, this, this.classId);
                $event.notify(eventTypes.FEATURES_MODIFIED, { oldFeatures: this.features, newFeatures: this.modifiedFeatures, layerId: this.layerSettings.name }, this, this.classId);
            }
        };

        return handler;
    }

    _showEditOptions(features, layerSettings) {
        let template = ``;

        switch (layerSettings.geometryType) {
            case geomTypes.GEOM_POINT: template = this._getPointEditTemplate();
                break;
            case geomTypes.GEOM_LINE: template = this._getLineEditTemplate();
                break;
            case geomTypes.GEOM_POLYGON: template = this._getPolygonEditTemplate();
                break;
            default: template = this._getAllEditTemplate();
        }

        let div = document.createElement('div');
        div.innerHTML = template;

        this.mapContainer.append(div.firstChild);
        this.features = features;
        this.layerSettings = layerSettings;

        if (this.features == null || this.features.length == 0) {
            document.getElementById(this.removeFeature).style.display = 'none';

            if (document.getElementById(this.startMove) != null) {
                document.getElementById(this.startMove).style.display = 'none';
            }

            document.getElementById(this.cancelEdit).style.display = 'none';
        }

        this._addEditEvent();
    }

    _addEditEvent() {
        $event.notify(eventTypes.FEATURE_EDITOR_STARTED, { features: this.features, layerId: this.layerSettings.name }, this, this.classId);

        document.getElementById(this.cancelEdit).addEventListener('click', () => {
            $event.notify(eventTypes.LAYER_SELECTION_CLEARED, { layerId: this.layerSettings.name }, this, this.classId);
            $event.notify(eventTypes.FEATURE_EDITOR_CANCELED, null, this, this.classId);
            this._hideEditOptions();
        });

        document.getElementById(this.startEdit).addEventListener('click', () => {
            this._deselectAll();
            $event.notify(eventTypes.FEATURE_REMOVED, null, this, this.classId);
            document.getElementById(this.startEdit).classList.add('selected');
            $event.notify(eventTypes.CLEAR_TEMPORARY_FEATURES, { layerId: this.layerSettings.name }, this, this.classId);
            $event.notify(eventTypes.FEATURE_EDIT_STARTED, null, this, this.classId);
        });

        if (document.getElementById(this.startMove) != null) {
            document.getElementById(this.startMove).addEventListener('click', () => {
                this._deselectAll();
                document.getElementById(this.startMove).classList.add('selected');
                $event.notify(eventTypes.FEATURE_MOVE_STARTED, null, this, this.classId);
            });
        }

        document.getElementById(this.removeFeature).addEventListener('click', () => {
            this._deselectAll();
            document.getElementById(this.removeFeature).style.display = 'none';

            if (document.getElementById(this.startMove) != null) {
                document.getElementById(this.startMove).style.display = 'none';
            }

            $event.notify(eventTypes.FEATURE_REMOVED, null, this, this.classId);
        });
    }

    _deselectAll() {
        [...document.getElementsByClassName('feature-edit-option')].forEach(elem => {
            elem.classList.remove('selected');
        });
    }

    _hideEditOptions() {
        document.getElementById(this.temporaryEditWrapper).remove();
    }

    _getPointEditTemplate() {
        return `<div id="` + this.temporaryEditWrapper + `" class="temp-edit-wrapper">
            <div id="` + this.temporaryEditContainer + `"  class="temp-edit-container">
                <div id="` + this.saveEdit + `" class="feature-edit-option header-icon disabled" style="display:none;">
                    <i class="fal fa-save edit-option-icon" title="` + this.resourcesHandler.get('SaveEdit') + `"></i>
                </div>
                <div id="` + this.cancelEdit + `" class="feature-edit-option header-icon">
                    <i class="fal fa-times edit-option-icon" title="` + this.resourcesHandler.get('CancelEdit') + `"></i>
                </div>
                <div id="` + this.startEdit + `" class="feature-edit-option header-icon">
                    <i class="fal fa-pencil-paintbrush edit-option-icon" title="` + this.resourcesHandler.get('StartEdit') + `"></i>
                </div>
                <div id="` + this.removeFeature + `" class="feature-edit-option header-icon">
                    <i class="fal fa-trash-alt edit-option-icon" title="` + this.resourcesHandler.get('RemoveFeature') + `"></i>
                </div>
            </div>
        </div>`;
    }

    _getLineEditTemplate() {
        return `<div id="` + this.temporaryEditWrapper + `" class="temp-edit-wrapper">
            <div id="` + this.temporaryEditContainer + `"  class="temp-edit-container">
            </div>
        </div>`;
    }

    _getPolygonEditTemplate() {
        return `<div id="` + this.temporaryEditWrapper + `" class="temp-edit-wrapper">
            <div id="` + this.temporaryEditContainer + `"  class="temp-edit-container">
            </div>
        </div>`;
    }

    _getAllEditTemplate() {
        return `<div id="` + this.temporaryEditWrapper + `" class="temp-edit-wrapper">
            <div id="` + this.temporaryEditContainer + `"  class="temp-edit-container">
            </div>
        </div>`;
    }
}